module.exports = __webpack_public_path__ + "img/9788925533674.7cec8927.jpg";